export default __webpack_public_path__ + "static/media/Roboto-BlackItalic.77e50ab1.ttf";